import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { Device, AppleDevice } from '@era/locations-sdk';
import { filter } from 'rxjs/operators';
import { DeviceStoreSelectors } from '@era/stores';
import { DeviceSwappedCurrentActionBarComponent } from './device-swapped-current-action-bar.component';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'era-device-swapped-current-action-bar',
  templateUrl: './device-swapped-current-action-bar.container.html',
  styleUrls: ['./device-swapped-current-action-bar.container.scss'],
  imports: [DeviceSwappedCurrentActionBarComponent, AsyncPipe],
})
export class DeviceSwappedCurrentActionBarContainerComponent {
  public readonly allowUnavailable$: Observable<boolean>;
  public readonly allowSpare$: Observable<boolean>;
  public readonly device$: Observable<Device>;

  constructor(
    private readonly deviceStore: Store<Device>,
    private readonly appleDeviceStore: Store<AppleDevice>
  ) {
    this.allowUnavailable$ = this.deviceStore.select(DeviceStoreSelectors.selectAllowedToMarkUnavailable);

    this.allowSpare$ = this.deviceStore.select(DeviceStoreSelectors.selectAllowedToMarkAsSpare);

    this.device$ = this.appleDeviceStore
      .select(DeviceStoreSelectors.selectDeviceByCurrentAppleDevice)
      .pipe(filter((device) => device !== undefined));
  }
}
